export default "__VITE_ASSET__Dx9m3cWe__"